/* tslint:disable */

/**
 */
export class ViewTemperature {
    temperature?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-temperature.ts